module.exports = __webpack_public_path__ + "static/media/4XL.c1f92f10.jpg";